import { ROUTES } from './routes'

export const PROFILE_INFO_SECTION_QUERY_PARAM = 'type'
export const PROFILE_INFO_SECTION_TYPES = ['health', 'targets', 'body'] as const
export const DEFAULT_PROFILE_INFO_SECTION_TYPE: ProfileInfoSectionType = 'health'

export type ProfileInfoSectionType = (typeof PROFILE_INFO_SECTION_TYPES)[number]

export function isProfileInfoSectionType(
	value: string | null
): value is ProfileInfoSectionType {
	return PROFILE_INFO_SECTION_TYPES.includes(value as ProfileInfoSectionType)
}

export function hasProfileInfoSectionSearch(search: string): boolean {
	const params = new URLSearchParams(search)
	return isProfileInfoSectionType(params.get(PROFILE_INFO_SECTION_QUERY_PARAM))
}

export function getProfileInfoSectionPath(type: ProfileInfoSectionType): string {
	return `${ROUTES.overall.profile}?${PROFILE_INFO_SECTION_QUERY_PARAM}=${type}`
}
